import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  sidebarOpen = false;
  readonly expandedMenus = new Set<string>();

  constructor(
    public readonly auth: AuthService,
    private readonly router: Router
  ) {}

  get isAuthPage(): boolean {
    return this.router.url.startsWith('/login') || this.router.url.startsWith('/auth/callback');
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  toggleMenu(path: string): void {
    if (this.expandedMenus.has(path)) this.expandedMenus.delete(path);
    else this.expandedMenus.add(path);
  }

  isMenuExpanded(path: string): boolean {
    return this.expandedMenus.has(path);
  }

  logout(): void {
    void this.auth.logout();
  }
}
